import { useSettings } from '@/hooks/useSettings';
import { eigeneHosts, hostsAusEinstellung } from '@/lib/scan';

/**
 * Die Hosts, deren QR-Codes als unsere gelten (#39, A28).
 *
 * Der eigene Host steckt immer drin — dafür braucht es keine Antwort vom
 * Server. Die Einstellung `scan_hosts` kommt dazu, sobald sie da ist:
 * solange die Abfrage läuft (oder fehlschlägt), gilt eben nur der eigene.
 * Das ist die richtige Reihenfolge des Ausfalls — ein Zettel von der
 * ALTEN Domain wird in der ersten halben Sekunde nach dem Laden nicht
 * erkannt, ein Zettel von der eigenen immer.
 *
 * Die Einstellung ist normalerweise leer und wird nur für die Zeit nach
 * einem Domain-Umzug gesetzt, solange gedruckte Zettel mit der alten
 * Adresse im Laden liegen (DEPLOY-NOTES.md, „Umzug auf eine andere
 * Domain“).
 */
export function useScanHosts(): string[] {
  const settings = useSettings(['scan_hosts']);
  // Beide Fragezeichen sind noetig, nicht nur das erste: `settings` fehlt
  // in der Antwort, sobald der Server sie nicht mitschickt — und dann
  // wuerde `data.settings.scan_hosts` werfen, mitten im Zeichnen. Ein
  // Scanner, der wegen einer fehlenden Einstellung die halbe Ansicht
  // mitreisst, waere schlimmer als einer ohne Zusatz-Hosts.
  return eigeneHosts(hostsAusEinstellung(settings.data?.settings?.scan_hosts));
}
